import { render, staticRenderFns } from "./ListStock.vue?vue&type=template&id=2ceca84e&scoped=true"
import script from "./ListStock.vue?vue&type=script&lang=js"
export * from "./ListStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceca84e",
  null
  
)

export default component.exports